import axios from 'axios';

// Variáveis de ambiente para diferentes ambientes
const DEV_API_URL = 'http://localhost:3010/api';
const PROD_API_URL = 'https://api.executor.coverforce.com.br/api';

// Define a URL da API com base no ambiente
export const API_URL = import.meta.env.MODE === 'production' 
  ? (import.meta.env.VITE_API_URL || PROD_API_URL)
  : (import.meta.env.VITE_API_URL || DEV_API_URL);

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  console.log('auth_header',token)
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };

  if (token) {
    headers['Authorization'] = token;
  }

  return headers;
};

export const api = axios.create({
  baseURL: API_URL,
  headers: getAuthHeaders(),
}); 